import Builder from './class-builder';

class EconomyBuilder extends Builder {

  /*
  * Render path for desktop
  */
  getRenderPathDesktop() {
    return this.renderDomain + 'economy-spiral-stair/desktop/';
  }

  /*
  * Render path for mobile
  */
  getRenderPathMobile() {
    return this.renderDomain + 'economy-spiral-stair/mobile/';
  }

  /*
  * Create image SKU
  */
  getRenderImage() {
    return 'SE' + this.getWidthImage(this.selection_data.width) + '09' + this.getFinishImage(this.selection_data.finish) + this.getTreadTypeImage(this.selection_data.tread_type) + this.getHandrailImage(this.selection_data.handrail);
  }

  /*
  * Match width SKU
  */
  getWidthImage(width) {
    switch (width) {
      case '36':
      case '50':
        return width;
      case '40':
      case '46':
        return '36';
      case '56':
      case '60':
        return '50';
      default:
        return '36';
    }
  }

  /*
  * Match finish SKU
  */
  getFinishImage(finish) {
    switch (finish) {
      case 'P':
      case 'G':
        return finish;
      default:
        return 'P';
    }
  }

  /*
  * Match tread type SKU
  */
  getTreadTypeImage(tread_type) {
    switch (tread_type) {
      case 'D':
      case 'R':
      case 'S':
        return tread_type;
      default:
        return 'S';
    }
  }

  /*
  * Match handrail SKU
  */
  getHandrailImage(handrail) {
    switch (handrail) {
      case 'A':
      case 'V':
        return handrail;
      default:
        return 'A';
    }
  }

  /*
  * Create sku from object
  * The order of the sku matches the spreadsheet from Mary
  */
  setSku() {
    this.sku = this.selection_data.product_line + this.selection_data.width + this.selection_data.height + this.selection_data.finish + this.selection_data.tread_type + this.selection_data.handrail;
  }

  /*
  * Create object from sku
  * The order of the sku matches the spreadsheet from Mary
  */
  getSkuObject(sku) {
    var product_line,
        width,
        height,
        finish,
        tread_type,
        handrail,
        selection_data = {};

    if (sku) {
      product_line = sku.substring(0, 2);
      width = sku.substring(2, 4);
      height = sku.substring(4, 6);
      finish = sku.substring(6, 7);
      tread_type = sku.substring(7, 8);
      handrail = sku.substring(8, 9);


      selection_data = {
        'product_line' : product_line,
        'width' : width,
        'height' : height,
        'finish' : finish,
        'tread_type' : tread_type,
        'handrail' : handrail,

      }
    }

    this.selection_data = selection_data;
    return selection_data;
  }

}

export default EconomyBuilder;
